import { FormElement, BlockContentProps } from '../FormElements';
import './BlockContent.css';
import CustomInput from './CustomInput';
import CustomSelect from './CustomSelect';

function BlockContent(props: BlockContentProps){
    const elements:FormElement[] = props.elements;

    return(
        <div className='block-content df fdc aic jcsb'>
            {
                elements.map((element:FormElement) => (
                    <div key={ element.id } className='form-element'>
                        { 
                        element.type === 'select' ? (
                            <div className='select-element'>
                                <label htmlFor={ element.id }>{ element.label }</label>
                                <CustomSelect 
                                    id = { element.id } 
                                    options = { element.options }
                                    changeSubject={ element.changeSubject }
                                    onChange = {
                                        {
                                            data: element.onChange.data,
                                            buttonState: element.onChange.buttonState,
                                            button: element.onChange.button
                                        }
                                    }
                                />
                            </div>
                        ) : (
                            <div className='input-element'>
                                <CustomInput 
                                    id={ element.id } 
                                    name={ element.label } 
                                    min={ element.min } 
                                    max={ element.max } 
                                    onChange={ element.onChange }
                                />
                            </div>
                        )}
                    </div>
                ))
            }
        </div>
    )
}

export default BlockContent;